import React from 'react';

import NotificationContainer from './NotificationContainer';
import ValidationErrorNotification from './types/validationError';
import InProgressNotification from './types/inProgress';
import PendingReviewNotification from './types/pendingReview';
import SuspendedNotification from './types/suspended';
import { userTypes } from '../../../../utils/constants';

const PendingReview = 'PendingReview';

const Notification = ({
  sections,
  isGenerationStarted,
  companyType,
  conditions,
  creation,
  handleSubmitDocument,
  unofficialGrade,
  companyId,
  isSuspended,
  suspensionContactInfo,
}) => {
  return (
    <>
      <NotificationContainer open={companyType === userTypes.Contractor && isSuspended} error>
        <SuspendedNotification contactInfo={suspensionContactInfo} />
      </NotificationContainer>

      <NotificationContainer
        open={isGenerationStarted && companyType === userTypes.Contractor && sections.length > 0 && !isSuspended}
        error
      >
        <ValidationErrorNotification />
      </NotificationContainer>

      <NotificationContainer
        open={isGenerationStarted && companyType === userTypes.Contractor && !sections.length && !isSuspended}
        success
      >
        <InProgressNotification
          {...unofficialGrade}
          creation={creation}
          handleSubmitDocument={handleSubmitDocument}
          companyId={companyId}
          userType={companyType}
        />
      </NotificationContainer>

      <NotificationContainer
        open={
          companyType === userTypes.Contractor && conditions.currentPqfDocumentStatus === PendingReview && !isSuspended
        }
        warning
      >
        <PendingReviewNotification />
      </NotificationContainer>
    </>
  );
};

export default Notification;
